import styled from "styled-components";
import theme from "../../../../../styles/theme";
export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  color: black;
  width: 100%;
  height: 100%;
  row-gap: 1vh;
  margin-top: 4vh;
  margin-bottom: 4vh;
  .item {
    color: ${theme.colors.brown.primary};
    font-size: ${theme.fontSize.md2};
    display: flex;
    flex-direction: row;
    align-items: center;
    column-gap: 1vw;
    place-self: center;
  }
`;
export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  margin-top: 16px;
  justify-content: center;
`;
